/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkOrderMergeSuggestionClusterDto
 */
export interface WorkOrderMergeSuggestionClusterDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderMergeSuggestionClusterDto
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderMergeSuggestionClusterDto
     */
    isoWeekKey: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkOrderMergeSuggestionClusterDto
     */
    workOrderIds: Array<string>;
}

/**
 * Check if a given object implements the WorkOrderMergeSuggestionClusterDto interface.
 */
export function instanceOfWorkOrderMergeSuggestionClusterDto(value: object): value is WorkOrderMergeSuggestionClusterDto {
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('isoWeekKey' in value) || value['isoWeekKey'] === undefined) return false;
    if (!('workOrderIds' in value) || value['workOrderIds'] === undefined) return false;
    return true;
}

export function WorkOrderMergeSuggestionClusterDtoFromJSON(json: any): WorkOrderMergeSuggestionClusterDto {
    return WorkOrderMergeSuggestionClusterDtoFromJSONTyped(json, false);
}

export function WorkOrderMergeSuggestionClusterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderMergeSuggestionClusterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'siteId': json['siteId'],
        'isoWeekKey': json['isoWeekKey'],
        'workOrderIds': json['workOrderIds'],
    };
}

export function WorkOrderMergeSuggestionClusterDtoToJSON(json: any): WorkOrderMergeSuggestionClusterDto {
    return WorkOrderMergeSuggestionClusterDtoToJSONTyped(json, false);
}

export function WorkOrderMergeSuggestionClusterDtoToJSONTyped(value?: WorkOrderMergeSuggestionClusterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteId': value['siteId'],
        'isoWeekKey': value['isoWeekKey'],
        'workOrderIds': value['workOrderIds'],
    };
}

